import { render, staticRenderFns } from "./FollowUs.vue?vue&type=template&id=7696b601&scoped=true&"
import script from "./FollowUs.vue?vue&type=script&lang=ts&"
export * from "./FollowUs.vue?vue&type=script&lang=ts&"
import style0 from "./FollowUs.vue?vue&type=style&index=0&id=7696b601&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7696b601",
  null
  
)

export default component.exports